<template>
  <div>
    <div class="row" ref="stripeCreditCard">
      <div class="col">
        <strong>Credit Card</strong>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="form-control">
          <label for="card-number" class="form-label">Card Number</label>
          <div class="stripe-field" id="card-number" ref="number"></div>
          <span class="validation-errors"
                v-for="error in errors.collect('stripe_credit_card_number')">{{ error }}</span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6 col-sm-6 col">
        <div class="form-control">
          <label for="expiry-date" class="form-label">Expiration Date</label>
          <div class="stripe-field" id="expiry-date" ref="expiryDate"></div>
          <span class="validation-errors"
                v-for="error in errors.collect('stripe_credit_card_expiry_date')">{{ error }}</span>
        </div>
      </div>
      <div class="col-lg-6 col-sm-6 col">
        <div class="form-control">
          <label for="cvv" class="form-label">CVV</label>
          <div class="stripe-field" id="cvv" ref="cvv"></div>
          <span class="validation-errors"
                v-for="error in errors.collect('stripe_credit_card_cvv_code')">{{ error }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import paymentMethodMixin from "@mixins/paymentMethodMixin";
import {CheckoutErrorException} from "@app/exceptions/CheckoutError";

export default {
  name: 'stripeCreditCard',
  mixins: [paymentMethodMixin],
  data: () => ({
    loading: false,
    token: null,
    cartNumber: null,
    cardExpiry: null,
    cardCvc: null,
    stripeInstance: null
  }),
  computed: {
    publishableKey() {
      return this.paymentMethod.public?.clientKey || null
    },
    elements() {
      return this.stripeInstance && this.stripeInstance.elements()
    }
  },
  mounted() {
    this.stripeInstance = window.Stripe(this.publishableKey);

    if (this.elements) {
      const style = {
        base: {
          color: 'black',
          lineHeight: 1.5,
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: 'antialiased',
          fontSize: '16px',
          '::placeholder': {
            color: '#495057',
          },
        },
        invalid: {
          color: '#dc3545',
          iconColor: '#dc3545',
        },
        complete: {
          color: 'green',
          iconColor: 'green'
        }
      };
      this.cardNumber = this.elements.create('cardNumber', {style});
      this.cardNumber.mount(this.$refs['number']);
      this.cardExpiry = this.elements.create('cardExpiry', {style});
      this.cardExpiry.mount(this.$refs['expiryDate']);
      this.cardCvc = this.elements.create('cardCvc', {style});
      this.cardCvc.mount(this.$refs['cvv']);
    }
  },
  methods: {
    tokenCreated(token) {
      console.log(`Stripe token ${token}`)

      this.token = token
    },
    async prePaymentRequest() {
      return await new Promise(async (resolve, reject) => {

        if (this.isPaymentTypeAlreadySet) {
          return resolve(true);
        }

        const {deviceData} = this;

        this.errors.remove('stripe_credit_card_number')
        this.errors.remove('stripe_credit_card_expiry_date')
        this.errors.remove('stripe_credit_card_cvv_code')

        this.stripeInstance.createToken(this.cardNumber).then((payload) => {
          console.log(payload)

          if (payload?.error) {
            const error = payload.error
            throw new CheckoutErrorException(error.type, error.code, error.message)
          } else {
            this.$store.commit('payment/setPaymentType', this.paymentMethodName);
            this.$store.commit('payment/setPaymentData', Object.assign({}, payload, {deviceData}))

            return resolve(true);
          }
        }).catch(error => {
          this.$store.dispatch('payment/reset');

          if (!this.errors.count()) {
            this.$scrollTo(this.$refs['stripeCreditCard']);
          }

          if (error.code === "incomplete_number") {
            this.errors.add({
              field: 'stripe_credit_card_number',
              msg: error.message
            });
          } else if (['incomplete_expiry', 'invalid_expiry_year_past'].includes(error.code)) {
            this.errors.add({
              field: 'stripe_credit_card_expiry_date',
              msg: error.message
            });
          } else if (['incomplete_cvc'].includes(error.code)) {
            this.errors.add({
              field: 'stripe_credit_card_cvv_code',
              msg: error.message
            });
          } else {
            this.errors.add({
              field: 'stripe_credit_card_number',
              msg: error.message
            });
          }

          return reject(false);
        })
      });
    },
  }
}
</script>

<style scoped lang="scss">
.stripe-field {
  display: block;
  width: 100%;
  height: calc(1.5em + .75rem + 2px);
  padding: .375rem .75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: .25rem;
  transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
}
</style>
